// extracted by mini-css-extract-plugin
export default {"authWrapper":"AuthPage_authWrapper__kQwMz","auth__bg":"AuthPage_auth__bg__aLhQe","auth__content":"AuthPage_auth__content__AziQ3"};